import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { AlertTriangle, ArrowUp, ArrowDown, Minus } from 'lucide-react';
import DashboardCard from './DashboardCard';
import {
  ListRow, RowMain, RowName, RowSub, RowSide,
} from '../styles';
import { SEVERITY_COLORS, formatTry } from '../constants';
import { initialsOf } from './RecentTransactionsCard';
import RowAvatar from './RowAvatar';

const Rank = styled.span`
  width: 16px;
  flex-shrink: 0;
  font-size: 12px;
  font-weight: 800;
  color: #9CA3AF;
`;

const AmountText = styled.div`
  font-size: 13px;
  font-weight: 800;
  color: ${({ theme }) => theme.colors.text.primary};
`;

const Delta = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 3px;
  font-size: 11px;
  font-weight: 700;
  color: #6B7280;
`;

export default function TopSpendersCard({ slice }) {
  const { t } = useTranslation();
  const items = slice.data?.items || [];

  return (
    <DashboardCard
      cardKey="en-cok-harcayanlar"
      title={t('expenseDashboard.topSpenders.title')}
      meta={t('expenseDashboard.topSpenders.meta')}
      span={4}
      spanMd={3}
      loading={slice.loading}
      empty={items.length === 0}
      emptyText={t('expenseDashboard.topSpenders.empty')}
    >
      <div>
        {items.map((item, index) => {
          const delta = item.prevMonthTotal > 0
            ? Math.round(((item.monthTotal - item.prevMonthTotal) / item.prevMonthTotal) * 100)
            : null;
          const DeltaIcon = delta === null || delta === 0 ? Minus : delta > 0 ? ArrowUp : ArrowDown;
          return (
            <ListRow key={item.userId}>
              <Rank>{index + 1}</Rank>
              <RowAvatar src={item.profilePicture} name={item.fullName} initials={initialsOf(item.fullName)} />
              <RowMain>
                <RowName>
                  {item.fullName}
                  {item.hasViolation && (
                    <AlertTriangle size={12} color={SEVERITY_COLORS.critical} style={{ marginLeft: 5, verticalAlign: 'middle' }} />
                  )}
                </RowName>
                <RowSub>{[item.department, item.location].filter(Boolean).join(' · ')}</RowSub>
              </RowMain>
              <RowSide>
                <AmountText>{formatTry(item.monthTotal)}</AmountText>
                <Delta>
                  <DeltaIcon size={11} />
                  {delta === null ? t('expenseDashboard.topSpenders.new') : `%${Math.abs(delta)}`}
                </Delta>
              </RowSide>
            </ListRow>
          );
        })}
      </div>
    </DashboardCard>
  );
}
